<template>
  <RemotePaginatedList :hide-search="hideSearch"
                       :filter-options="filterOptions"
                       :headers="headers"
                       multi-sort
                       :show-select="showSelect"
                       v-model="selectedItemIds"
                       data-url="aafb/admin/discount_code/records/"
                       data-key="records"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       v-on="$listeners"
                       v-bind="$attrs">
    <template #item.create_at="{value}">
      {{ $parseDate(value) }}
    </template>
    <template #item.account="{value}">
      {{ value ? $t('name', {given_name: value.given_name, surname: value.surname}) : '' }}
    </template>
  </RemotePaginatedList>
</template>

<script>
import _ from 'lodash';
import {computed, onMounted, ref, watch} from '@vue/composition-api'
import RemotePaginatedList from "@/components/RemotePaginatedList";
import {BOOKING_STATUS, BOOKING_STATUS_LABEL} from "@/constants";
import EditDiscountCodeModal from "@/components/acc_booking/discount_code/EditDiscountCodeModal.vue";
import ListDiscountCodeRecordModal from "@/components/acc_booking/discount_code/ListDiscountCodeRecordModal.vue";

export default {
  name: 'AdminDiscountCodeRecordList',
  components: {RemotePaginatedList},
  props: {
    value: Array,
    hideSearch: Boolean,
    showSelect: Boolean,
    refreshTrigger: Boolean,
  },
  setup(props, {root, emit}) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh();
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh();
        emit('update:refresh-trigger', false);
      }
    })

    // Filter
    const filterOptions = computed(() => {
      return [
        {text: root.$t('admin_acc_discount_code_record.created_at'), value: 'create_at', datetime_date_range: true},
        {text: root.$t('admin_user.serial_no'), value: 'account.hkiarace_account.id', contains: true},
      ]
    })

    // Data Table
    const headers = ref([
      {text: root.$t('admin_acc_discount_code_record.created_at'), value: 'create_at'},
      {text: root.$t('admin_user.serial_no'), value: 'account.hkiarace_id', sortable: false},
      {text: root.$t('admin_acc_member.title'), value: 'account'},
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(() => selectedItemIds.value, (newValue) => {
      emit('input', newValue);
    });

    watch(() => props.value, (newValue, oldValue) => {
      if (_.xor(newValue, oldValue).length) {
        selectedItemIds.value = newValue;
      }
    }, {deep: true, immediate: true})

    const deleteItem = function (item) {
      if (confirm(root.$t('admin_acc_discount_code.delete_confirm_msg'))) {
        root.$callAPI('aafb/admin/discount_code/delete/', {
          discount_code_id: item.id,
        }, (response) => {
          refresh();
        })
      }
    }
    const editItem = async function (item) {
      await root.$dialog.showAndWait(EditDiscountCodeModal, {
        discountCodeId: item.id,
        persistent: true,
        width: '80vw',
      })
    };
    const listItemRecords = async function (item) {
      await root.$dialog.showAndWait(ListDiscountCodeRecordModal, {
        discountCodeId: item.id,
        persistent: true,
        width: '80vw',
      })
    }

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      BOOKING_STATUS,
      BOOKING_STATUS_LABEL,

      deleteItem,
      editItem,
      listItemRecords,
    }
  }
}
</script>
